import { defaultPreset } from '@/features/theme/config.js'

const initialState = {
  colors: {
    primary: defaultPreset.semantic.colorScheme.light.primary.color,
    inverse: defaultPreset.semantic.colorScheme.light.primary.inverseColor,
    hover: defaultPreset.semantic.colorScheme.light.primary.hoverColor,
    active: defaultPreset.semantic.colorScheme.light.primary.activeColor,
  },
  cssVars: {
    '--fm-ui-auth-layout-primary-color': '',
    '--fm-ui-auth-layout-text-color': '',

    '--p-button-primary-background': '',
    '--p-button-primary-color': '',
    '--p-button-primary-border-color': '',
  },
}

export const authLayoutThemeManager = {
  setProperty(name, value) {
    const target = document.querySelector('.auth-layout-theme-wrapper')

    if (!target) {
      //console.error('authLayoutThemeManager.setProperty: target not found')
      return
    }

    target.style.setProperty(name, value)
  },

  removeProperty(name) {
    const target = document.querySelector('.auth-layout-theme-wrapper')

    if (!target) {
      // console.error('authLayoutThemeManager.setProperty: target not found')
      return
    }
    target.style.removeProperty(name)
  },

  resetAllProperties() {
    Object.keys(initialState.cssVars).forEach(key => {
      this.removeProperty(key)
    })
  },

  setButtonColors(backgroundColor, textColor) {
    this.setProperty('--p-button-bg', backgroundColor)
    this.setProperty('--p-button-text', textColor)
    this.setProperty('--p-button-border', backgroundColor)

    const hoverBg = this.adjustColor(backgroundColor, -10)
    this.setProperty('--p-button-hover-bg', hoverBg)
    this.setProperty('--p-button-hover-text', textColor)
    this.setProperty('--p-button-hover-border', hoverBg)

    const activeBg = this.adjustColor(backgroundColor, -20)
    this.setProperty('--p-button-active-bg', activeBg)
    this.setProperty('--p-button-active-text', textColor)
    this.setProperty('--p-button-active-border', activeBg)
  },

  adjustColor(color, percent) {
    if (!color) {
      return null
    }

    const num = parseInt(color.replace('#', ''), 16),
      amt = Math.round(2.55 * percent),
      R = (num >> 16) + amt,
      G = ((num >> 8) & 0x00ff) + amt,
      B = (num & 0x0000ff) + amt
    return (
      '#' +
      (
        0x1000000 +
        (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
        (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
        (B < 255 ? (B < 1 ? 0 : B) : 255)
      )
        .toString(16)
        .slice(1)
    )
  },
}

export function setThemeColor({ backgroundColor, textColor }) {
  authLayoutThemeManager.setProperty('--p-button-primary-background', backgroundColor)
  authLayoutThemeManager.setProperty('--p-button-primary-border-color', backgroundColor)
  authLayoutThemeManager.setProperty('--p-button-primary-color', textColor)

  authLayoutThemeManager.setProperty('--fm-ui-auth-layout-primary-color', backgroundColor)
  authLayoutThemeManager.setProperty('--fm-ui-auth-layout-text-color', textColor)

  authLayoutThemeManager.setProperty('--p-button-primary-hover-background', backgroundColor)
  authLayoutThemeManager.setProperty('--p-button-primary-hover-border-color', backgroundColor)
  authLayoutThemeManager.setProperty('--p-button-primary-hover-color', textColor)

  authLayoutThemeManager.setProperty('--p-button-primary-active-background', backgroundColor)
  authLayoutThemeManager.setProperty('--p-button-primary-active-border-color', backgroundColor)
  authLayoutThemeManager.setProperty('--p-button-primary-active-color', textColor)

  authLayoutThemeManager.setButtonColors(backgroundColor, textColor)
}
